export const getApplicationDisplayName = application =>
  application?.displayName?.trim() || application?.name || '';
